import { TaskState } from '../enums/task-state.enum';

export interface UpdateTaskDto {
    description?: string;

    assignedTo?: string | null;

    dueDate?: Date;

    taskState?: TaskState;
}
